import { ROUTES } from 'app/core/router/paths';

/**
 * @description 流程步驟代碼
 */
export enum ProcessStepCodesEnum {
  /** 同意相關告知事項 (Step-1) */
  Clauses = '1',
  /** 驗證身分 (Step-2) */
  OTPAuth = '2'
}

/**
 * @description 流程步驟文字
 */
export enum ProcessStepTextEnum {
  /** 同意相關告知事項 (Step-1) */
  Clauses = '同意相關告知事項',
  /** 驗證身分 (Step-2) */
  OTPAuth = '驗證身分'
}

/**
 * @description 流程路由對應步驟代碼
 */
export const ProcessRouteMatchesStep: Readonly<Record<string, ProcessStepCodesEnum>> = {
  /** 同意相關告知事項 (Step-1) */
  [ROUTES.MEMBER__REAUTH__CLAUSES]: ProcessStepCodesEnum.Clauses,
  /** 驗證身分 (Step-2) */
  [ROUTES.MEMBER__REAUTH__OTP_AUTH]: ProcessStepCodesEnum.OTPAuth
};

/**
 * @description 流程步驟代碼對應路由
 */
export const ProcessStepMatchesRoute: Readonly<Record<ProcessStepCodesEnum, string>> = {
  /** 同意相關告知事項 (Step-1) */
  [ProcessStepCodesEnum.Clauses]: ROUTES.MEMBER__REAUTH__CLAUSES,
  /** 確認資料 (Step-2) */
  [ProcessStepCodesEnum.OTPAuth]: ROUTES.MEMBER__REAUTH__OTP_AUTH
};
